export const Auditoria = {
  Transaccion: {
    CitasMedicas: {
      Nombre: "Citas Médicas",
      Funcionalidades: {
        AgendarCita: {
          Valor: "Agendar Cita",
        },
        ReagendarCita: {
          Valor: "Reagendar Cita",
        },
        CancelarCita: {
          Valor: "Cancelar Cita",
        },
        LevantarIncumplimiento: {
          Valor: "Levantar Incumplimiento",
        },
      },
    },
    Certificaciones: {
      Nombre: "Certificaciones Salud",
      Funcionalidades: {
        AportesPBS: {
          Programa: "PBS",
          Valor: "Certificado Aportes PBS",
        },
        EstadoAfiliacionPBS: {
          Programa: "PBS",
          Valor: "Certificado Estado Afiliación",
        },
        UPCAdicional: {
          Programa: "PBS",
          Valor: "Solicitud de Certificado UPC Adicional",
        },
        CarnePBS: {
          Programa: "PBS",
          Valor: "Carné PBS",
        },
        EstadoAfiliacionPC: {
          Programa: "PC",
          Valor: "Certificado Estado Afiliación PC",
        },
        AntiguedadAfiliacionPC: {
          Programa: "PC",
          Valor: "Certificado Antiguedad Afiliación PC",
        },
        PagosPC: {
          Programa: "PC",
          Valor: "Certificado Pagos PC",
        },
        Retefuente: {
          Programa: "PC",
          Valor: "Certificado Retención en la Fuente",
        },
        PagosPorPeriodo: {
          Programa: "Empresas",
          Valor: "Certificado Pagos por Periodo",
        },
        AportesAnuales: {
          Programa: "Empresas",
          Valor: "Certificado Aportes Anuales a la EPS",
        },
      },
      ValorSi: "Si",
      ValorNo: "No",
    },
    ResultadosExamenes: {
      Nombre: "Resultados de exámenes médicos",
      Funcionalidades: {
        TipoExamen: { TipoExamen: "Consultar Laboratorio" },
        EnvioEmail: { EnvioEmail: "Enviar Laboratorio" },
      },
    },
    ReporteEmpleados: {
      Nombre: "Reporte de empleados",
      Funcionalidades: {
        ReporteMayor200: {
          "Nombre de reporte generado": "Reporte por todos los empleados",
          "Tipo de consulta realizada": "{0}",
          NumeroRadicado: "{1}",
        },
        ReporteMenor200: {
          "Nombre de reporte generado": "Reporte por todos los empleados",
          "Tipo de consulta realizada": "{0}",
        },
        ReporteUnTrabajador: {
          "Nombre de reporte generado":
            "Solicitar reporte de un (1) trabajador",
          "Tipo de consulta realizada": "{0}",
        },
      },
    },
    CambioUnidadServicio: {
      Nombre: "Cambio Unidad Servicio",
      Funcionalidades: {
        Radicar: { NumeroRadicado: "{0}" },
      },
    },
    CertificacionesMasivas: {
      Nombre: "Certificaciones masivas",
      Funcionalidades: {
        AfiliacionPBSUnTrabajador: {
          "Nombre de certificación generada": "Estado de afiliación PBS",
          "Tipo de consulta realizada":
            "Solicitar certificado para un trabajador",
        },
        AfiliacionPBSGrupoTrabajadores: {
          "Nombre de certificación generada": "Estado de afiliación PBS",
          "Tipo de consulta realizada":
            "Solicitar certificado para un grupo de trabajadores",
        },
        AfiliacionPBSTodosTrabajadores: {
          "Nombre de certificación generada": "Estado de afiliación PBS",
          "Tipo de consulta realizada":
            "Solicitar certificado para todos los trabajadores",
        },
        AfiliacionPCUnTrabajador: {
          "Nombre de certificación generada": "Estado de afiliación PC",
          "Tipo de consulta realizada":
            "Solicitar certificado para un trabajador",
        },
        AfiliacionPCGrupoTrabajadores: {
          "Nombre de certificación generada": "Estado de afiliación PC",
          "Tipo de consulta realizada":
            "Solicitar certificado para un grupo de trabajadores",
        },
        AfiliacionPCTodosTrabajadores: {
          "Nombre de certificación generada": "Estado de afiliación PC",
          "Tipo de consulta realizada":
            "Solicitar certificado para todos los trabajadores",
        },
        RetencionPCUnTrabajador: {
          "Nombre de certificación generada":
            "Estado de retención en la fuente PC",
          "Tipo de consulta realizada":
            "Solicitar certificado para un trabajador",
        },
        RetencionPCGrupoTrabajadores: {
          "Nombre de certificación generada":
            "Estado de retención en la fuente PC",
          "Tipo de consulta realizada":
            "Solicitar certificado para un grupo de trabajadores",
        },
        RetencionPCTodosTrabajadores: {
          "Nombre de certificación generada":
            "Estado de retención en la fuente PC",
          "Tipo de consulta realizada":
            "Solicitar certificado para todos los trabajadores",
        },
        PagosPCUnTrabajador: {
          "Nombre de certificación generada": "Certificado de pagos PC",
          "Tipo de consulta realizada":
            "Solicitar certificado para un trabajador",
        },
        PagosPCGrupoTrabajadores: {
          "Nombre de certificación generada": "Certificado de pagos PC",
          "Tipo de consulta realizada":
            "Solicitar certificado para un grupo de trabajadores",
        },
        PagosPCTodosTrabajadores: {
          "Nombre de certificación generada": "Certificado de pagos PC",
          "Tipo de consulta realizada":
            "Solicitar certificado para todos los trabajadores",
        },
      },
    },
    CertificacionesEmpleados: {
      Nombre: "Certificaciones Masivas",
      Funcionalidades: {
        CertificacionUnTrabajador: {
          "Nombre de certificación generada": "Estado de afiliación {0}",
          "Tipo de consulta realizada":
            "Solicitar Certificado para un trabajador",
        },
        CertificacionTodosLosTrabajadores: {
          "Nombre de certificación generada": "Estado de afiliación {0}",
          "Tipo de consulta realizada":
            "Solicitar Certificado para todos los trabajadores",
        },
        RetencionUnTrabajador: {
          "Nombre de certificación generada":
            "Estado de retención en la fuente PC",
          "Tipo de consulta realizada":
            "Solicitar Certificado para un trabajador",
        },
        PagosUnTrabajador: {
          "Nombre de certificación generada": "Certificado de pagos PC",
          "Tipo de consulta realizada":
            "Solicitar Certificado para un trabajador",
        },
      },
    },
    Incapacidades: {
      Nombre: "Incapacidades",
      Funcionalidades: {
        ConsultaHistorico: {
          Formato: "JSON",
          ProgramaAfiliacion: "Empresa",
          DatosAdicionales:
            'Consultar histÃ³rico de incapacidades", "Fecha Inicial: {0}", "Fecha Final:{1}", "Criterio de consulta:{2}',
        },
      },
    },
  },
}